import axios from "axios";

const CONFIGURED = process.env.REACT_APP_BACKEND_URL;
// Every linked domain serves /api from the same app, so stay on the shopper's own address (no blocked cross-site calls or cookies).
export const BACKEND = window.location.hostname === "localhost" ? CONFIGURED : window.location.origin;

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

export const money = (n) => `$${Number(n).toFixed(2)}`;

export const imgUrl = (src) => (src?.startsWith("/api/") ? `${BACKEND}${src}` : src);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d[0]?.msg?.replace(/^Value error, /, "") || "Please check the form.";
  return typeof d === "string" ? d : "Something went wrong. Please try again.";
};
